import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {CfFrequencyObjectComponent} from "./component/object-components/cf-frequency-object-component/cf-frequency-object.component";
import {CfRoundingRuleObjectComponent} from "./component/object-components/cf-rounding-rule-object-component/cf-rounding-rule-object.component";

export const CF_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['cf.CfFrequency', {route: '/cf/frequencies', objectComponent: [{component: CfFrequencyObjectComponent}]}],
            ['cf.CfPayFrequency', {route: '/cf/payFrequencies'}],
            ['cf.CfPaymentMoment', {route: '/cf/paymentMoments'}],
            ['cf.CfPaymentType', {route: '/cf/paymentTypes'}],
            ['cf.CfRoundingRule', {route: '/cf/roundingRules', objectComponent: [{component: CfRoundingRuleObjectComponent}]}],
            ['cf.CfTemplateCalculationBase', {route: '/cf/templateCalculationBases'}],
            ['cf.CfTemplateCancellationBuffer', {route: '/cf/templateCancellationBuffers'}],
            ['cf.CfTemplateLiability', {route: '/cf/templateLiabilities'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
